// extracted by mini-css-extract-plugin
export default {"tupacGrid":"Ci-z","tupacHeader":"Di-z","tupacHeader2":"Ei-z","tupacMenu":"Fi-z","tupacMenu2":"Gi-z","tupacMain":"Hi-z","tupacMain2":"Ii-z"};